import { SortingSettings } from "../models";

export const SortingSettingsDefault: SortingSettings = {
  pageSize: 5,
  ascending: undefined,
  orderBy: undefined,
};
